export const showLocaleModal = () => {
  window.dispatchEvent(
    new CustomEvent('show-locale-modal'),
  )
}
